<template>
	<div v-testid="'notifications-list'" :class="$style.notifications">
		<template v-if="notifications.length === 0">
			<div v-testid="'notifications-empty'" :class="$style['notifications__empty']">
				<h3 :class="$style['notifications__title']">
					{{ $t('notifications.empty.title') }}
				</h3>
				<h4 :class="$style['notifications__subtitle']">
					{{ $t('notifications.empty.subtitle') }}
				</h4>
			</div>
		</template>
		<template v-else>
			<Notification
				v-for="(notification, index) in notifications"
				:key="index"
				:notification="notification"
				@success="$emit('success', $event)"
				@delete="$emit('delete', $event)"
			/>
		</template>
	</div>
</template>

<script>
import Notification from './Notification'
export default {
	name: 'Notifications',
	components: {
		Notification
	},
	props: {
		notifications: {
			type: Array,
			required: true
		}
	}
}
</script>

<style lang="scss" module>

	.notifications {
		max-height: 250px;
		overflow: hidden;
		overflow-y: scroll;

		&__empty {
			padding: 30px 20px;
			text-align: center;
		}

		&__title {
			margin: 0;
			margin-bottom: 5px;
			font-size: 16px;
			font-weight: normal;
		}

		&__subtitle {
			margin: 0;
			font-size: 12px;
			font-weight: normal;
			color: getColor(helper-text);
		}
	}
</style>
